import Logo from '@/components/shared/Logo.tsx';
import LanguageSelector from '@/components/shared/LanguageSelector.tsx';
import ThemeToggle from '@/components/shared/ThemeToggle.tsx';
import ProfileMenu from '@/components/layout/ProfileMenu.tsx';
import { useAuth } from '@/context/AuthContext.tsx';

// Cabecera MVP compartida: la misma barra de la home y de login/registro
// (logo izq.; idioma + tema + menú de perfil dcha.). La usan MvpHomePage y el
// layout post-login de los usuarios normales (sin sidebar).
export default function MvpHeader() {
  const { isAuthenticated } = useAuth();

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-card/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo size="md" linkTo="/" />
        <div className="flex items-center gap-2">
          <LanguageSelector />
          <ThemeToggle />
          {isAuthenticated && <ProfileMenu />}
        </div>
      </div>
    </header>
  );
}
